import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import enHK from './translations/en-HK.json'
import zhHK from './translations/zh-HK.json'
import enSG from './translations/en-SG.json'
import zhTW from './translations/zh-TW.json'
import viVN from './translations/vi-VN.json'
import enIN from './translations/en-IN.json'

const resources = {
  'en-HK': {
    translation: enHK,
  },
  'zh-HK': {
    translation: zhHK,
  },
  'en-SG': {
    translation: enSG,
  },
  'zh-TW': {
    translation: zhTW,
  },
  'vi-VN': {
    translation: viVN,
  },
  'en-IN': {
    translation: enIN,
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: process.env.REACT_APP_LOCALE,

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n
